/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReleaseNoteEntryDto } from '../models/ReleaseNoteEntryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentationControllerService {
    /**
     * @returns ReleaseNoteEntryDto OK
     * @throws ApiError
     */
    public static readReleaseNotes({
        noteId,
    }: {
        noteId: string,
    }): CancelablePromise<Array<ReleaseNoteEntryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/account/documentation/release-notes/{noteId}',
            path: {
                'noteId': noteId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static openDocument({
        documentId,
    }: {
        documentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/account/documentation/{documentId}',
            path: {
                'documentId': documentId,
            },
        });
    }
}
